const CACHE_KEY = 'v_creator_hybrid_cached_state';

export enum GlobalDialogType {
  ResourcePreview = 'ResourcePreview',
  Default = '',
}
export interface State {
  cachedState: {
    [key: string]: {
      persistent: boolean;
      data: any;
    };
  };
}

const state: State = {
  cachedState: {},
};

const mutations = {
  SET_CACHED_STATE: (state: State, { key, payload }: { key: string; payload: any }) => {
    state.cachedState[key] = payload;
  },
  SYNC_CACHED_STATE: (state: State) => {
    state.cachedState = JSON.parse(localStorage.getItem(CACHE_KEY) || '{}');
  },
  STORE_CURRENT_STATE: (state: State) => {
    const validCachedState = { ...state.cachedState };
    Object.keys(validCachedState).forEach((k) => {
      if (!validCachedState[k].persistent) {
        Reflect.deleteProperty(validCachedState, k);
      }
    });
    localStorage.set(CACHE_KEY, JSON.stringify(validCachedState));
  },
  CLEAR_CURRENT_STATE: (state: State) => {
    state.cachedState = {};
  },
  DELETE_STATE_BY_KEY: (state: State, { key }: { key: string }) => {
    if (typeof key === 'string') {
      Reflect.deleteProperty(state.cachedState, key);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
